export default __webpack_public_path__ + "static/media/mainPage_bar.3800293e.jpg";